/*
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-24 09:48:20
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-06-06 17:00:32
 * @FilePath: /goldenSalesMobile/src/utils/index.js
 * @Description: 公用工具类
 */
import wx from "weixin-js-sdk";
import { getUserIsAuth, getOpenId } from "@/api/user";
// 手机号正则
export const mobileReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;

// loading
import { Toast } from "vant";
export const loading = () => {
  Toast.loading({
    // mask: true, //蒙层
    duration: 0, // 持续展示 toast
    forbidClick: true, // 禁用背景点击
    loadingType: "spinner",
    message: "加载中...",
  });
};

/**
 * param 将要转为URL参数字符串的对象
 * key URL参数字符串的前缀
 * encode true/false 是否进行URL编码,默认为true
 * return URL参数字符串
 */
export function urlEncode(param, key, encode) {
  if (param === null || param === "") return "";
  var paramStr = "";
  var t = typeof param;
  if (t === "string" || t === "number" || t === "boolean") {
    if (paramStr !== "") paramStr += "&";
    paramStr += key + "=" + param;
  } else {
    for (var i in param) {
      var k =
        key == null
          ? i
          : key + (param instanceof Array ? "[" + i + "]" : "." + i);
      const rt = urlEncode(param[i], k, encode);
      if (paramStr !== "" && rt !== "") paramStr += "&";
      paramStr += rt;
    }
  }
  return paramStr;
}

/**
 * @description: 获取url后面的参数
 * @param {type} 要获取的参数名
 * @return:
 */
export function getUrlParam(name) {
  console.log("99999<<<  name  >>>99999");
  console.log(name);
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg); //匹配目标参数
  console.log("99999<<<  r  >>>99999");
  console.log(r);
  if (r != null) return unescape(r[2]);
  return null; //返回参数值
}

/**
 * @description: 同步imageBaseUrl
 * @param {type}
 * @return:
 */
import { getImageToken } from "@/api/system";
export async function getImagebaseUrl() {
  // 缓存中取imageToken
  let imageToken = sessionStorage.getItem("imageToken");
  if (imageToken) {
    imageToken = JSON.parse(imageToken);
  } else {
    imageToken = await getImageToken();
    sessionStorage.setItem("imageToken", JSON.stringify(imageToken));
  }
  return imageToken.UploadUrl;
}

/**
 * @description: 判断当前时间是否在某个时间段内
 * @param date [beginDateStr] [开始时间]
 * @param date [endDateStr] [结束时间]
 * @return: Boolean
 */
export function isDuringDate(beginDateStr, endDateStr) {
  let curDate = new Date().getTime(),
    beginDate = new Date(beginDateStr.replace(/-/g, "/")).getTime(),
    endDate = new Date(endDateStr.replace(/-/g, "/")).getTime();
  if (curDate >= beginDate && curDate <= endDate) {
    return true;
  }
  return false;
}

// 对象数组根据某属性分组
export function arrayGroupBy(array, f) {
  let groups = {};
  array.forEach(function (o) {
    var group = f(o) == null ? "" : JSON.stringify(f(o));
    groups[group] = groups[group] || [];
    groups[group].push(o);
  });
  return Object.keys(groups).map(function (group) {
    return groups[group];
  });
}
// 封装storage
export const handleLocalStorage = {
  set(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  get(key) {
    return localStorage.getItem(key) &&
      localStorage.getItem(key) !== "undefined"
      ? JSON.parse(localStorage.getItem(key))
      : null;
  },
  remove(key) {
    localStorage.removeItem(key);
  },
};
// 封装sessionStorage
export const handleSessionStorage = {
  set(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  },
  get(key) {
    return sessionStorage.getItem(key) &&
      sessionStorage.getItem(key) !== "undefined"
      ? JSON.parse(sessionStorage.getItem(key))
      : null;
  },
  remove(key) {
    sessionStorage.removeItem(key);
  },
};
// 封装设置有效期的storage
export const handleTimeLocalStorage = {
  set(key, value, expire) {
    let obj = {
      data: value,
      time: Date.now(),
      expire: expire,
    };
    localStorage.setItem(key, JSON.stringify(obj));
  },
  get(key) {
    let val = localStorage.getItem(key);
    if (!val) {
      return val;
    }
    val = JSON.parse(val);
    if (Date.now() - val.time > val.expire) {
      localStorage.removeItem(key);
      return null;
    }
    return val.data;
  },
};
export function handleScanCode(scanObj, successCallback, failCallback) {
  wx.ready(() => {
    wx.scanQRCode({
      desc: "scanQRCode desc",
      needResult: (scanObj && scanObj.needResult) || 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果
      scanType: ["qrCode", "barCode"],
      success: (res) => {
        if (successCallback) successCallback(res);
      },
      fail: (err) => {
        if (failCallback) failCallback(err);
      },
    });
  });
}
export const dateFormat = (d, pattern = "yyyy-MM-dd") => {
  const y = d.getFullYear().toString(),
    o = {
      M: d.getMonth() + 1, //month
      d: d.getDate(), //day
      h: d.getHours(), //hour
      m: d.getMinutes(), //minute
      s: d.getSeconds(), //second
    };
  pattern = pattern.replace(/(y+)/gi, function (a, b) {
    return y.substr(4 - Math.min(4, b.length));
  });
  for (const i in o) {
    pattern = pattern.replace(new RegExp("(" + i + "+)", "g"), function (a, b) {
      return o[i] < 10 && b.length > 1 ? "0" + o[i] : o[i];
    });
  }
  return pattern;
};

//获取当前时间前n天的日期
export const getCurrentPreviousDay = (day = 1) => {
  let date = new Date();
  var oneweekdate = new Date(date.getTime() - day * 24 * 3600 * 1000);
  console.log(oneweekdate);
  return dateFormat(oneweekdate);
};
export function handleAuthUserInfo(callback) {
  getUserIsAuth().then((res) => {
    if (!res) {
      //未授权
      // snsapi_userinfo:非静默授权，第一次有弹框,snsapi_base:静默授权，没有弹窗
      const code = getUrlParam("code"); // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接获取openId
      // const code = this.$route.query.code // 注意：this.$route.query.code是无法获取到code的：http://golden.ticket.goldenyun.cn/?code=061Slqge2CSNNI0Xhsie2nhGge2Slqgk&state=1#/sales/goods-list
      const appId = handleLocalStorage.get("appId");
      const componentAppId = handleLocalStorage.get("componentAppId");
      const codeData = handleLocalStorage.get("loginCode");
      const local = window.location.href;
      console.log(code);
      console.log(codeData);
      if (code == null || code === "" || (codeData && codeData == code)) {
        handleLocalStorage.remove("loginCode");
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          appId +
          "&redirect_uri=" +
          encodeURIComponent(local) +
          "&response_type=code&scope=snsapi_base&state=1&component_appid=" +
          componentAppId +
          "#wechat_redirect";
      } else {
        console.log("授权后调用接口，获取用户头像等信息");
        getOpenId(code).then((res) => {
          if (callback) callback();
        });
      }
    } else {
      console.log(8888888888);
      if (callback) callback();
    }
  });
}
